import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from "lz-string";
import { createJSONStorage } from "zustand/middleware";

export const urlStorage = {
  parse: (value?: string | null) => {
    if (!value) return null;

    try {
      const decompressed = decompressFromEncodedURIComponent(value);
      return decompressed ? JSON.parse(decompressed) : null;
    } catch {
      return null;
    }
  },
  getItem: (name: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    const value = searchParams.get(name);

    if (!value) return null;

    try {
      const decompressed = decompressFromEncodedURIComponent(value);
      return decompressed ? JSON.parse(decompressed) : null;
    } catch {
      return null;
    }
  },

  // eslint-disable-next-line
  setItem: (name: string, value: any) => {
    const searchParams = new URLSearchParams(window.location.search);

    const compressed = compressToEncodedURIComponent(JSON.stringify(value));
    searchParams.set(name, compressed);

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
  },

  removeItem: (name: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(name);

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
  },
};

export const zustandStorage = createJSONStorage(() => urlStorage);

export const rawDefaultStateValuesGetter = (key: string) => () => {
  try {
    return JSON.parse(urlStorage.getItem(key) ?? "{}")["state"] ?? {};
  } catch {
    return {};
  }
};
